import MojitoServices from 'mojito/services';

import {merge} from '#core/utils/config-utils.js';
import {resolveBackground} from '#core/utils/color-utils.js';

import {generatePromotionQuickLinks} from '#core/application/modules/tiles/promotion-quick-links/index.js';
import {generateSkeletonPart} from '#core/application/modules/tiles/skeleton-part/index.js';
import {generatePivotsRow} from '#core/application/modules/tiles/pivot/index.js';
import {generatePriceBoostLabel} from '#core/application/modules/tiles/price-boost-label/index.js';

const {LOCATION} = MojitoServices.Promotions.types;

export function homePageFactory(PALETTE) {
    const {FONT} = PALETTE;

    const HOME_PAGE_TOP_SPORTS_SKELETON = generateSkeletonPart(PALETTE.HOME_PAGE_TOP_SPORTS_SKELETON_PART);
    const PRICE_BOOST_ICON = generatePriceBoostLabel(PALETTE.HOME_PAGE_PROMOTION_QUICK_LINKS_PRICE_BOOST_LABEL);

    return {
        HomePage: {
            primaryContentLayout: {
                createStackingContext: true,
            },
            topContextMenu: {
                priceBoostLink: {
                    iconContainer: merge(PRICE_BOOST_ICON.container, {
                        style: {
                            padding: '0px',
                        },
                    }),
                    iconBackground: PRICE_BOOST_ICON.iconContainer,
                    icon: PRICE_BOOST_ICON.icon,
                },
                // Mobile Quick Links
                rowLinkMenu: merge(generatePromotionQuickLinks(PALETTE.HOME_PAGE_PROMOTION_QUICK_LINKS), {
                    // Mojito bug MOJ-14479
                    menuRow: {
                        item: {
                            unselected: {
                                style: {
                                    base: {
                                        flexGrow: 0,
                                    },
                                },
                            },
                        },
                        buttonScrollPane: {
                            contentContainer: {
                                style: {
                                    _mobile_padding: '0 0 0 8px',
                                },
                            },
                        },
                    },
                }),
            },
            topLinkPromotions: {
                _mobile_locationId: LOCATION.TOP_QUICK_LINKS,
                menuRowSkeleton: {
                    container: {
                        style: {
                            ...resolveBackground(PALETTE.HOME_PAGE_TOP_SPORTS_CONTAINER_BG),
                            padding: '12px 4px',
                        },
                    },
                    iconPlaceholder: HOME_PAGE_TOP_SPORTS_SKELETON,
                    linkPlaceholder: HOME_PAGE_TOP_SPORTS_SKELETON,
                },
                menuRow: merge(generatePivotsRow(PALETTE.HOME_PAGE_TOP_SPORTS_ROW), {
                    style: {
                        container: {
                            ...resolveBackground(PALETTE.HOME_PAGE_TOP_SPORTS_CONTAINER_BG),
                            height: '48px',
                            padding: '4px 0',
                            alignItems: 'center',
                        },
                    },
                    item: {
                        // only unselected because these items cannot be selected
                        unselected: {
                            style: {
                                base: {
                                    padding: 0,
                                    fontSize: FONT.SIZE_XXSMALL,
                                    fontWeight: FONT.WEIGHT_NORMAL,
                                    ...PALETTE.HOME_PAGE_TOP_SPORTS_ROW.PIVOT_TEXT,
                                },
                            },
                        },
                    },
                    itemIcon: {
                        style: {
                            width: '20px',
                            maxWidth: '20px',
                            height: '20px',
                            maxHeight: '20px',
                        },
                    },
                }),
            },
            topBannerPromotions: {
                locationId: LOCATION.TOP,
            },
            // minimum requirement to prevent mojito from crashing
            leftPromotions: {
                locationId: LOCATION.LEFT,
            },
        },
    };
}
